import React, { useContext } from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { getMenuAdminAccountConfiguration } from '@totem/components/ui_components/menus/mainMenu/admin_account_configuration';
import TabContentMenu from '@totem/components/ui_components/menus/tabContentMenu';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const ConfigurationPage = () => {
  const { userProfile } = useContext(UserProfileContext);

  return (
    <ContentLayout>
      <IBCard isCovered>
        <TabContentMenu items={getMenuAdminAccountConfiguration(userProfile)} />
      </IBCard>
    </ContentLayout>
  );
};

export default ConfigurationPage;
